export const headerLinks = [
  {
    id: "1",
    name: "Programs",
    dropDown: [
      {
        id: "mlp",
        name: "Marketing Launchpad",
        link: "/marketing-launchpad/digital-marketing-course/",
        subinnerLevel: [
          {
            heading: "Full-time",
            courses: [
              {
                id: "dmm",
                name: "Digital Marketing Course",
                link: "/marketing-launchpad/digital-marketing-course/",
                description: "Online | 22 Weeks",
              },
            ],
          },
          {
            heading: "Part-time",
            courses: [
              {
                id: "dmm_part_time",
                name: "Digital Marketing Course - Weekend",
                link:
                  "/marketing-launchpad/part-time-digital-marketing-course/",
                description: "Online | 11 months",
              },
            ],
          },
          {
            heading: "Emerging talent",
            courses: [
              {
                id: "dmm_hindi",
                name: "Digital Marketing Course in Hindi",
                link: "/marketing-launchpad/digital-marketing-course-in-hindi/",
                description: "Online | 19 Weeks",
              },
            ],
          },
        ],
      },
      // {
      //   id: "csm",
      //   name: "Content and Social Media Launchpad",
      //   link: "/content-writing-course/",
      //   // subinnerLevel: []
      // },
      {
        id: "bsl",
        name: "PGP in Sales, Marketing and Business Leadership",
        link: "/sales-course/",
        // subinnerLevel: []
      },
      // {
      //   id: "ice",
      //   name: "INDUSTRYCreds™ Certification",
      //   link: "/industrycreds-experience/",
      // },
      {
        id: "career-placement",
        name: "Placement",
        link: "https://placement-reports.kraftshala.com/",
      },
    ],
  },
  // {
  //   id: "2",
  //   name: "Benefits",
  //   dropDown: [
  //     {
  //       id: "ice",
  //       name: "IndustryCreds™ Certification",
  //       link: "/industrycreds-experience/",
  //     },
  //     {
  //       id: "career-placement",
  //       name: "Career Placement",
  //       link: "/career-support/",
  //     },
  //     {
  //       id: "alumni-stories",
  //       name: "Alumni Stories",
  //       link: "/alumni/",
  //     },
  //   ],
  // },
  {
    id: "2",
    name: "Free Resources",
    dropDown: [
      {
        id: "ks-live",
        name: "Kraftshala Live",
        link: "/kraftshala-live/",
      },
      {
        id: "blog",
        name: "Blogs",
        link: "/blog/",
      },
      {
        id: "marketing-glossary",
        name: "Marketing Glossary",
        link: "/marketing-glossary/",
      },
      {
        id: "press-releases",
        name: "Press Releases",
        link: "/press-releases/",
      },
    ],
  },
  {
    id: "3",
    name: "Alumni Connect",
    link: "https://reviews.kraftshala.com/",
    dropDown: [],
  },
  {
    id: "4",
    name: "Hire from Us",
    link: "/hire-from-us/",
    dropDown: [
      // {
      //   id: "hire-icp",
      //   name: "Hire from Us",
      //   link: "/hire-from-us/",
      // },
      // {
      //   id: "train-team",
      //   name: "Train your team",
      //   link: "/corporate-trainings/",
      // },
    ],
  },
];
